import { render } from "./DettaglioRapportino.vue?vue&type=template&id=cf328802&scoped=true"
import script from "./DettaglioRapportino.vue?vue&type=script&lang=js"
export * from "./DettaglioRapportino.vue?vue&type=script&lang=js"

import "./DettaglioRapportino.vue?vue&type=style&index=0&id=cf328802&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf328802"]])

export default __exports__